
import { Routes } from '@angular/router';
import { VideoBoardAuthComponent } from './video-board-auth.component';

export const videoBoardAuthRoutes: Routes = [
  {
    path: ':deviceId',
    component: VideoBoardAuthComponent,
  }
];